import SubscribeForm from '@/components/feature/SubscribeForm';
import { siteInfo } from '@/mocks/site';

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="w-full bg-background-50 py-12 md:py-16 scroll-mt-32">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 rounded-lg border border-background-200 overflow-hidden">
          <div className="p-6 md:p-10 bg-background-100">
            <span className="inline-flex items-center gap-1.5 text-xs tracking-wide text-accent-800 bg-accent-50 border border-accent-200 px-2.5 py-1 rounded-full">
              <i className="ri-notification-3-line"></i>
              热点订阅
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">
              不想一直刷？让热点自己来找你
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              订阅后，我们会在每天固定时段把当日讨论量最高的事件整理成一封邮件，包含要点速览与原文链接，读完大约三分钟。
            </p>
            <ul className="mt-5 space-y-2.5">
              {['只发送热点更新，不发营销内容', '可随时回复邮件取消订阅', '线索投稿也会在这里被优先看到'].map(
                (line) => (
                  <li key={line} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-check-line mt-0.5 text-accent-600"></i>
                    {line}
                  </li>
                ),
              )}
            </ul>
            <p className="mt-5 text-xs text-foreground-500">
              <i className="ri-mail-line mr-1"></i>
              也可以直接写信到 {siteInfo.email}
            </p>
          </div>

          <div className="p-6 md:p-10 bg-background-50">
            <h3 className="font-heading text-lg font-bold text-foreground-950">填写订阅信息</h3>
            <p className="mt-1.5 text-sm text-foreground-600 mb-5">
              留一个常用邮箱，选择你最关心的方向即可。
            </p>
            <SubscribeForm />
          </div>
        </div>
      </div>
    </section>
  );
}